import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { ScarcityBar } from './components/ScarcityBar';
import { Hero } from './components/Hero';
import { Hook } from './components/Hook';
import { Problem } from './components/Problem';
import { Revelation } from './components/Revelation';
import { Modules } from './components/Modules';
import { ValueStack } from './components/ValueStack';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { Closing } from './components/Closing';
import { StickyCta } from './components/StickyCta';
import { PurchaseNotifications } from './components/PurchaseNotifications';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-full w-full bg-ink font-sans text-white" data-id="element-0" data-mp="2whxcnx635uha">
      <ScarcityBar data-id="element-1" data-mp="28t4j27cxrypu" />
      <Hero data-id="element-2" data-mp="28sbbj465l56n" />
      <main data-id="element-3" data-mp="28s2ztflro5x1">
        <Hook data-id="element-4" data-mp="23vkwmk634fmt" />
        <Problem data-id="element-5" data-mp="23vupcfiil0w7" />
        <Revelation data-id="element-6" data-mp="23u9vyt7xrnzx" />
        <Modules data-id="element-7" data-mp="23v2rey1g2r2r" />
        <ValueStack data-id="element-8" data-mp="23ti8y6semyl9" />
        <Guarantee data-id="element-9" data-mp="3ik7fqfdqo9q4" />
        <Faq data-id="element-10" data-mp="3ikqy1x7ax04o" />
        <Closing data-id="element-11" data-mp="3ij64oawq3n8e" />
      </main>
      <footer className="border-t border-line bg-surface px-5 py-10 pb-28 sm:px-8" data-id="element-12" data-mp="3ihv2ugmu8pjx">
        <div className="mx-auto flex max-w-5xl flex-col items-center gap-2 text-center" data-id="element-13" data-mp="3mjzpgvevclx2">
          <p className="font-display text-xl font-bold uppercase tracking-tightest text-white" data-id="element-14" data-mp="3rcsxpt9jqcdw">
            The HYROX Coach Blueprint
          </p>
          <p className="font-sans text-xs leading-relaxed text-muted" data-id="element-15" data-mp="2zl3dbpgpde7f">
            © {new Date().getFullYear()} The HYROX Coach Blueprint. This product
            is an independent educational resource and is not affiliated with or
            endorsed by HYROX.
          </p>
        </div>
      </footer>
      <StickyCta data-id="element-16" data-mp="3dkl5met7j9lj" />
      <PurchaseNotifications data-id="element-17" data-mp="3dl4llpzarnwx" />
    </div>;
}